import React from 'react';
import { usePopup } from './PopupContext';
import Popup from './Popup';

const GlobalPopupHandler: React.FC = () => {
  const { popup, isVisible, hidePopup } = usePopup();

  return (
    <>
      {isVisible && popup && (
        <Popup popupModel={popup} closePopup={hidePopup} />
      )}
    </>
  );
};

export default GlobalPopupHandler;